// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3sgG-","title":"ClientReferral_title__21Lmy","itemText":"ClientReferral_itemText__CAePT"};